export const isRunningTest = () => window.Cypress;

export const isAddSuppliersModalPopupDisabled = () =>
  isRunningTest() && window.Cypress.disableAddSuppliersModalPopup;
